"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgDonate = function (props) {
    var color = props.color;
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.35 12.132A5.982 5.982 0 0 1 12 14a5.983 5.983 0 0 1-4.35-1.868A4.771 4.771 0 0 0 4 16.77 2.23 2.23 0 0 0 6.23 19H7a1 1 0 1 1 0 2h-.77A4.23 4.23 0 0 1 2 16.77a6.772 6.772 0 0 1 4.495-6.379 6 6 0 1 1 11.009 0A6.772 6.772 0 0 1 22 16.77 4.23 4.23 0 0 1 17.77 21H17a1 1 0 1 1 0-2h.77A2.23 2.23 0 0 0 20 16.77a4.771 4.771 0 0 0-3.65-4.638ZM16 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z", fill: color }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 15.307a2.809 2.809 0 0 1 3.184.442c.515.485.816 1.157.816 1.87 0 .713-.301 1.385-.816 1.87L12.9 21.644a1.317 1.317 0 0 1-1.8 0L8.816 19.49a2.551 2.551 0 0 1 0-3.74c.867-.819 2.163-.966 3.184-.442ZM13.28 17c-.211 0-.402.08-.533.203l-.746.704-.746-.704a.8.8 0 0 0-1.066 0 .552.552 0 0 0 0 .832L12 19.744l1.811-1.71A.572.572 0 0 0 14 17.62a.572.572 0 0 0-.188-.415.779.779 0 0 0-.533-.204Z", fill: color })));
};
exports.default = factorySvgIcon_1.default(SvgDonate);
//# sourceMappingURL=SvgDonate.js.map